// Miroir frontend de backend/config/orgLevels.js (slugs + fallback FR).
// Niveau ORGANISATIONNEL (rang), distinct de la séniorité/expertise.
// Labels EN/ES via i18n (forms:experience.organizational_level.<slug>), fallback FR.
// Propager tout ajout/retrait dans backend/config/orgLevels.js.

export const ORG_LEVEL_VALUES = [
  'individual_contributor',
  'team_lead',
  'manager',
  'head',
  'director',
  'vp',
  'c_level',
  'founder_owner',
  'other',
]

export const ORG_LEVEL_LABELS = {
  individual_contributor: 'Contributeur individuel',
  team_lead: "Chef d'équipe",
  manager: 'Manager',
  head: 'Responsable / Head of',
  director: 'Directeur',
  vp: 'VP',
  c_level: 'Comité de direction (C-level)',
  founder_owner: 'Fondateur / Dirigeant',
  other: 'Autre',
}

export const getOrganizationalLevelLabel = (slug, t) => {
  if (!slug) return ''
  if (t) return t(`forms:experience.organizational_level.${slug}`, { defaultValue: ORG_LEVEL_LABELS[slug] || slug })
  return ORG_LEVEL_LABELS[slug] || slug
}

export const isValidOrganizationalLevel = (value) =>
  value === null || value === undefined || value === '' || ORG_LEVEL_VALUES.includes(value)
